export default __webpack_public_path__ + "static/media/Icon_GIF_Blue.68512bdd.png";